export class DefineKey {
  public static readonly KEY_MENU = "menu";
  public static readonly FUNCTIONS = 'functions'
  public static readonly PERMISSIONS = 'permission';
}